import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Import16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M7.767 4.0288C7.69521 4.0585 7.62795 4.10253 7.56959 4.16089L5.43915 6.29133C5.20144 6.52904 5.20144 6.91444 5.43915 7.15215C5.67686 7.38986 6.06227 7.38986 6.29998 7.15215L7.3913 6.06083V10.9826C7.3913 11.3188 7.66383 11.5913 8 11.5913C8.33617 11.5913 8.6087 11.3188 8.6087 10.9826V6.06083L9.70002 7.15215C9.93773 7.38986 10.3231 7.38986 10.5608 7.15215C10.7986 6.91444 10.7986 6.52904 10.5608 6.29133L8.43041 4.16089C8.32026 4.05074 8.16809 3.98261 8 3.98261"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M8 2.21739C4.80635 2.21739 2.21739 4.80635 2.21739 8C2.21739 11.1936 4.80635 13.7826 8 13.7826C11.1936 13.7826 13.7826 11.1936 13.7826 8C13.7826 4.80635 11.1936 2.21739 8 2.21739ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
